/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { FaGlobe, FaBars } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import logoArabic from "../../../assets/logoArabic.png";
import logoEnglish from "../../../assets/logoEnglish.png";
import { COLORS } from "./hero.constants";

export default function NavbarDesktop({ isArabic, onToggleLang, onToggleMenu }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="container-fluid d-flex justify-content-between align-items-center" style={{ direction: isArabic ? "rtl" : "ltr" }}>
      <a href="/" className="navbar-brand fw-bold">
        <img
          src={isArabic ? logoArabic : logoEnglish}
          alt="Madar Logo"
          style={{ height: "45px" }}
        />
      </a>

      <button className="btn border-0 d-lg-none" onClick={onToggleMenu}>
        <FaBars size={22} style={{ color: COLORS.gold }} />
      </button>

      <div className="d-none d-lg-flex align-items-center gap-3">
        <button
          className="btn border-0 d-flex align-items-center gap-1 fw-semibold"
          style={{ color: COLORS.textLight }}
          onClick={onToggleLang}
        >
          <FaGlobe color={COLORS.gold} /> {isArabic ? "EN" : "AR"}
        </button>

        <button
          className="btn fw-semibold"
          style={{
            color: COLORS.gold,
            border: `1px solid ${COLORS.gold}`,
            borderRadius: "8px",
            padding: "6px 14px",
            background: "transparent",
          }}
          onClick={() => navigate("/login")}
        >
          {t("login.signIn")}
        </button>

        <button
          className="btn fw-semibold px-3 py-2"
          style={{
            background: COLORS.gold,
            borderRadius: "10px",
            color: COLORS.darkPurple,
          }}
          onClick={() => navigate("/signup")}
        >
          {t("create")}
        </button>
      </div>
    </div>
  );
}
